/*Kelvin Roger Ang Yap 2017
	krayap@gmail.com
*/

Vue.component('kr-panel', require('./components/kr-panel.vue').default);
Vue.component('kr-pie-chart', require('./components/kr-pie-chart.vue').default);
Vue.component('kr-scatter-chart', require('./components/kr-scatter-chart.vue').default);
Vue.component('kr-bar-chart', require('./components/kr-bar-chart.vue').default);
Vue.component('kr-boxplot-chart', require('./components/kr-boxplot-chart.vue').default);
Vue.component('kr-math', require('./components/kr-math.vue').default);

